<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '90vw', maxWidth: '1400px' }"
    (onHide)="handleClose()" [draggable]="false">

    <!-- HEADER -->
    <div class="flex items-center justify-center dialog-header">
        {{ packageData ? 'Edit' : 'Create' }} Package
        <div class="absolute right-2">
            <button (click)="handleClose()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <!-- CONTENT -->
    <div class="dialog-content bg-gray-50/50">
        <div class="p-6">
            <form [formGroup]="packageForm" (ngSubmit)="submitForm()">
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">

                    <!-- LEFT SIDE FORM -->
                    <div class="lg:col-span-2 space-y-8">

                        <!-- BASIC INFORMATION -->
                        <div class="bg-white border border-gray-100 shadow-sm p-6 rounded-xl relative overflow-hidden">
                            <div class="absolute top-0 left-0 w-1 h-full bg-blue-500"></div>
                            
                            <h3 class="flex items-center gap-2 text-lg font-bold text-gray-800 mb-6 pb-2 border-b border-gray-100">
                                <i class="pi pi-info-circle text-blue-500"></i>
                                Basic Information
                            </h3>

                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <!-- EXISTING CLIENT -->
                                <div class="md:col-span-2">
                                    <label class="block mb-2 font-medium text-gray-700">
                                        Existing Client
                                    </label>
                                    <p-select
                                        [options]="clients"
                                        [(ngModel)]="selectedClientFilter"
                                        [ngModelOptions]="{ standalone: true }"
                                        optionLabel="label"
                                        optionValue="value"
                                        placeholder="Select an existing client..."
                                        [filter]="true"
                                        filterBy="label"
                                        [showClear]="true"
                                        appendTo="body"
                                        class="w-full">
                                        <ng-template pTemplate="selectedItem" let-selected>
                                            <div class="flex items-center gap-2" *ngIf="selected">
                                                <i class="pi pi-user text-blue-500"></i>
                                                <span>{{ selected.label }}</span>
                                            </div>
                                        </ng-template>
                                        <ng-template let-client pTemplate="item">
                                            <div class="flex items-center gap-2">
                                                <i class="pi pi-user text-gray-400"></i>
                                                <span>{{ client.label }}</span>
                                            </div>
                                        </ng-template>
                                    </p-select>
                                </div>

                                <!-- NAME -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Package Name <span class="text-red-500">*</span></label>
                                    <span class="p-input-icon-left w-full">
                                        <i class="pi pi-tag"></i>
                                        <input pInputText formControlName="package_name" class="w-full" placeholder="e.g. Gold Plan" />
                                    </span>
                                </div>

                                <!-- TYPE -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Type <span class="text-red-500">*</span></label>
                                    <p-select formControlName="type" [options]="typeOptions" optionLabel="label" optionValue="value" 
                                        class="w-full" placeholder="Select Type" appendTo="body"></p-select>
                                </div>

                                <!-- PRICE -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Price (INR) <span class="text-red-500">*</span></label>
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon text-gray-500">₹</span>
                                        <p-inputNumber formControlName="price" mode="decimal" [minFractionDigits]="0" class="w-full" placeholder="0.00"></p-inputNumber>
                                    </div>
                                </div>

                                <!-- BILLING CYCLE -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Billing Cycle <span class="text-red-500">*</span></label>
                                    <p-select (onChange)="updateValidityBasedOnCycle($event)" formControlName="billing_cycle" 
                                        [options]="billingCycles" optionLabel="label" optionValue="value" class="w-full" appendTo="body"></p-select>
                                </div>

                                <!-- VALIDITY -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Validity (days) <span class="text-red-500">*</span></label>
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="pi pi-calendar"></i></span>
                                        <p-inputNumber formControlName="validity" class="w-full" placeholder="Days"></p-inputNumber>
                                    </div>
                                </div>

                                <!-- STATUS -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Status <span class="text-red-500">*</span></label>
                                    <p-select formControlName="status" [options]="[{ label: 'Active', value: 'Active' }, { label: 'Inactive', value: 'Inactive' }]" 
                                        class="w-full" appendTo="body">
                                        <ng-template pTemplate="selectedItem" let-selected>
                                            <div class="flex items-center gap-2" *ngIf="selected">
                                                <span class="w-2 h-2 rounded-full" [ngClass]="{'bg-green-500': selected.value === 'Active', 'bg-gray-400': selected.value === 'Inactive'}"></span>
                                                {{ selected.label }}
                                            </div>
                                        </ng-template>
                                        <ng-template let-item pTemplate="item">
                                            <div class="flex items-center gap-2">
                                                <span class="w-2 h-2 rounded-full" [ngClass]="{'bg-green-500': item.value === 'Active', 'bg-gray-400': item.value === 'Inactive'}"></span>
                                                {{ item.label }}
                                            </div>
                                        </ng-template>
                                    </p-select>
                                </div>

                                <!-- SORT ORDER -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Sort Order <span class="text-red-500">*</span></label>
                                    <div class="p-inputgroup">
                                        <span class="p-inputgroup-addon"><i class="pi pi-sort-alt"></i></span>
                                        <p-inputNumber formControlName="sort_order" class="w-full" placeholder="0" [showButtons]="true" [min]="0" buttonLayout="horizontal"></p-inputNumber>
                                    </div>
                                    <small class="text-gray-500">Lower numbers appear first</small>
                                </div>

                                <!-- VISIBILITY -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Visibility <span class="text-red-500">*</span></label>
                                    <p-select formControlName="visibility" [options]="visibilityOptions" optionLabel="label" optionValue="value" 
                                        class="w-full" placeholder="Select Visibility" appendTo="body">
                                        <ng-template pTemplate="selectedItem" let-selected>
                                            <div class="flex items-center gap-2" *ngIf="selected">
                                                <i class="pi" [ngClass]="{
                                                    'pi-eye text-blue-500': selected.value === 'Public',
                                                    'pi-lock text-orange-500': selected.value === 'Private',
                                                    'pi-eye-slash text-gray-500': selected.value === 'Hidden'
                                                }"></i>
                                                {{ selected.label }}
                                            </div>
                                        </ng-template>
                                        <ng-template let-item pTemplate="item">
                                            <div class="flex items-center gap-2">
                                                <i class="pi" [ngClass]="{
                                                    'pi-eye text-blue-500': item.value === 'Public',
                                                    'pi-lock text-orange-500': item.value === 'Private',
                                                    'pi-eye-slash text-gray-500': item.value === 'Hidden'
                                                }"></i>
                                                {{ item.label }}
                                            </div>
                                        </ng-template>
                                    </p-select>
                                </div>

                                <!-- IS RECOMMENDED -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Recommended Package</label>
                                    <div class="flex items-center gap-3 mt-3">
                                        <p-inputSwitch formControlName="is_recommended"></p-inputSwitch>
                                        <span class="text-sm font-medium" [ngClass]="packageForm.value.is_recommended ? 'text-amber-600' : 'text-gray-400'">
                                            <i class="pi" [ngClass]="packageForm.value.is_recommended ? 'pi-star-fill' : 'pi-star'"></i>
                                            {{ packageForm.value.is_recommended ? 'Recommended' : 'Not Recommended' }}
                                        </span>
                                    </div>
                                </div>

                                <!-- IS TRIAL -->
                                <div>
                                    <label class="block mb-2 font-medium text-gray-700">Trial Package</label>
                                    <div class="flex items-center gap-3 mt-3">
                                        <p-inputSwitch formControlName="is_trial"></p-inputSwitch>
                                        <span class="text-sm font-medium" [ngClass]="packageForm.value.is_trial ? 'text-blue-600' : 'text-gray-400'">
                                            <i class="pi" [ngClass]="packageForm.value.is_trial ? 'pi-check-circle' : 'pi-circle'"></i>
                                            {{ packageForm.value.is_trial ? 'Trial Package' : 'Regular Package' }}
                                        </span>
                                    </div>
                                </div>

                                <!-- DESCRIPTION -->
                                <div class="md:col-span-2">
                                    <label class="block mb-2 font-medium text-gray-700">Description</label>
                                    <textarea pTextarea formControlName="description" rows="3" class="w-full" placeholder="Enter package description..."></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- CONFIGURATION TABS (Limits & Features) -->
                        <div class="bg-white border border-gray-100 shadow-sm rounded-xl overflow-hidden">
                            <p-tabView styleClass="package-tabs">
                                
                                <!-- LIMITS TAB -->
                                <p-tabPanel>
                                    <ng-template pTemplate="header">
                                        <div class="flex items-center gap-2">
                                            <i class="pi pi-chart-bar text-purple-500"></i>
                                            <span class="font-bold text-gray-700">Credits</span>
                                            <span class="bg-purple-100 text-purple-700 text-xs font-bold px-2 py-0.5 rounded-full" *ngIf="getLimits().length > 0">{{ getLimits().length }}</span>
                                        </div>
                                    </ng-template>

                                    <div class="p-4">
                                        <div class="flex justify-between items-center mb-4">
                                            <div>
                                                <p class="text-sm text-gray-500 mb-1">Define usage quotas for this package.</p>
                                                <p class="text-xs text-gray-400" *ngIf="getLimits().length > 0">
                                                    {{ getLimits().length }} of {{ limitFeatureOptions.length }} credits added
                                                </p>
                                            </div>
                                            <button type="button" pButton label="Add Credits" icon="pi pi-plus" (click)="addLimit()" size="small" outlined="true" severity="help"></button>
                                        </div>

                                        <!-- EMPTY STATE -->
                                        <div *ngIf="getLimits().length === 0" class="flex flex-col items-center justify-center p-8 bg-gray-50 border border-dashed border-gray-300 rounded-lg">
                                            <div class="w-10 h-10 bg-purple-50 rounded-full flex items-center justify-center mb-3">
                                                <i class="pi pi-sliders-h text-purple-400 text-lg"></i>
                                            </div>
                                            <p class="text-gray-500 font-medium m-0 text-sm">No usage credits defined</p>
                                        </div>

                                        <!-- LIMIT ROWS -->
                                        <div *ngIf="getLimits().length > 0" class="space-y-3">
                                            <div class="grid grid-cols-12 gap-4 px-2 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                                <div class="col-span-7">Credits Name</div>
                                                <div class="col-span-4">Value</div>
                                                <div class="col-span-1 text-center"></div>
                                            </div>
                                            
                                            <div *ngFor="let limit of getLimits(); let i = index" 
                                                class="grid grid-cols-12 gap-4 items-center bg-gray-50 p-2 rounded-lg border border-transparent hover:border-purple-200 transition-colors">
                                                <div class="col-span-7">
                                                    <p-select [(ngModel)]="limit.key" [ngModelOptions]="{ standalone: true }"
                                                        [options]="getAvailableLimitOptions(limit)" optionLabel="label" optionValue="feature_key" 
                                                        class="w-full" placeholder="Select credits type" appendTo="body" showClear="true"
                                                        (onChange)="onLimitChange($event, limit)"></p-select>
                                                </div>
                                                <div class="col-span-4">
                                                    <p-inputNumber [(ngModel)]="limit.value" [ngModelOptions]="{ standalone: true }" 
                                                        placeholder="Value" class="w-full" [showButtons]="true" [min]="0" buttonLayout="horizontal"
                                                        inputId="horizontal">
                                                    </p-inputNumber>
                                                </div>
                                                <div class="col-span-1 text-center">
                                                    <button pButton icon="pi pi-trash" class="p-button-danger p-button-text p-button-rounded" 
                                                        (click)="removeFeature(limit)" pTooltip="Remove"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </p-tabPanel>

                                <!-- FEATURES TAB -->
                                <p-tabPanel>
                                    <ng-template pTemplate="header">
                                        <div class="flex items-center gap-2">
                                            <i class="pi pi-check-circle text-teal-500"></i>
                                            <span class="font-bold text-gray-700">Features</span>
                                            <span class="bg-teal-100 text-teal-700 text-xs font-bold px-2 py-0.5 rounded-full" *ngIf="getFeatures().length > 0">{{ getFeatures().length }}</span>
                                        </div>
                                    </ng-template>

                                    <div class="p-4">
                                        <div class="flex justify-between items-center mb-4">
                                            <div>
                                                <p class="text-sm text-gray-500 mb-1">Toggle enabled features for this package.</p>
                                                <p class="text-xs text-gray-400" *ngIf="getFeatures().length > 0">
                                                    {{ getFeatures().length }} of {{ fixedFeatureOptions.length }} features added
                                                </p>
                                            </div>
                                            <button type="button" pButton label="Add Feature" icon="pi pi-plus" (click)="addFeature()" size="small" outlined="true" severity="success"></button>
                                        </div>

                                        <!-- EMPTY STATE -->
                                        <div *ngIf="getFeatures().length === 0" class="flex flex-col items-center justify-center p-8 bg-gray-50 border border-dashed border-gray-300 rounded-lg">
                                            <div class="w-10 h-10 bg-teal-50 rounded-full flex items-center justify-center mb-3">
                                                <i class="pi pi-list text-teal-400 text-lg"></i>
                                            </div>
                                            <p class="text-gray-500 font-medium m-0 text-sm">No features added</p>
                                        </div>

                                        <!-- FEATURE ROWS -->
                                        <div *ngIf="getFeatures().length > 0" class="space-y-3">
                                            <div class="grid grid-cols-12 gap-4 px-2 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                                <div class="col-span-7">Feature Name</div>
                                                <div class="col-span-4">Status</div>
                                                <div class="col-span-1 text-center"></div>
                                            </div>

                                            <div *ngFor="let feature of getFeatures(); let i = index" 
                                                class="grid grid-cols-12 gap-4 items-center bg-gray-50 p-2 rounded-lg border border-transparent hover:border-teal-200 transition-colors">
                                                <div class="col-span-7">
                                                    <p-select [(ngModel)]="feature.key" [ngModelOptions]="{ standalone: true }"
                                                        [options]="getAvailableFeatureOptions(feature)" optionLabel="label" optionValue="feature_key" 
                                                        class="w-full" placeholder="Select feature" appendTo="body" showClear="true"
                                                        (onChange)="onFeatureChange($event, feature)"></p-select>
                                                </div>
                                                <div class="col-span-4 flex items-center">
                                                    <div class="flex items-center gap-3">
                                                        <p-inputSwitch [(ngModel)]="feature.enabled" [ngModelOptions]="{ standalone: true }"></p-inputSwitch>
                                                        <span class="text-sm font-medium" [ngClass]="feature.enabled ? 'text-green-600' : 'text-gray-400'">
                                                            {{ feature.enabled ? 'Enabled' : 'Disabled' }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-span-1 text-center">
                                                    <button pButton icon="pi pi-trash" class="p-button-danger p-button-text p-button-rounded" 
                                                        (click)="removeFeature(feature)" pTooltip="Remove"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </p-tabPanel>

                            </p-tabView>
                        </div>
                    </div>

                    <!-- RIGHT SIDE PREVIEW -->
                    <div class="space-y-6">

                        <!-- PACKAGE PREVIEW CARD -->
                        <div class="sticky top-6">
                            <h3 class="font-semibold text-gray-700 mb-4 opacity-0 lg:opacity-100">Live Preview</h3>
                            
                            <div class="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden transform transition-all duration-300">
                                <!-- Banner Header -->
                                <div class="bg-gradient-to-r from-gray-900 to-gray-800 p-6 text-white text-center relative">
                                    <div class="absolute top-0 right-0 p-2 opacity-10">
                                        <i class="pi pi-star-fill text-6xl"></i>
                                    </div>
                                    <h3 class="text-2xl font-bold m-0 tracking-tight">{{ packageForm.value.package_name || 'Package Name' }}</h3>
                                    <span class="inline-block mt-2 px-3 py-1 bg-white/20 rounded-full text-xs font-medium uppercase tracking-wider backdrop-blur-sm">
                                        {{ packageForm.value.billing_cycle || 'Billing Cycle' }}
                                    </span>
                                </div>

                                <div class="p-6">
                                    <!-- Price -->
                                    <div class="text-center mb-6">
                                        <div class="flex items-center justify-center text-gray-800">
                                            <span class="text-xl font-semibold mt-1">₹</span>
                                            <span class="text-4xl font-extrabold tracking-tight mx-1 text-gray-900">{{ packageForm.value.price || 0 }}</span>
                                        </div>
                                        <p class="text-gray-500 text-sm">per {{ (packageForm.value.billing_cycle === 'Yearly' ? 'year' : (packageForm.value.billing_cycle === 'Quarterly' ? 'quarter' : 'month')) }}</p>
                                    </div>

                                    <!-- Description -->
                                    <div *ngIf="packageForm.value.description" class="p-4 bg-gray-50 rounded-xl mb-6 text-center text-gray-600 text-sm italic">
                                        {{ packageForm.value.description }}
                                    </div>

                                    <!-- TABBED PREVIEW FOR LIMITS & FEATURES -->
                                    <div class="border-t border-gray-100">
                                        <p-tabView styleClass="preview-tabs">
                                            
                                            <!-- LIMITS TAB -->
                                            <p-tabPanel>
                                                <ng-template pTemplate="header">
                                                    <div class="flex items-center gap-2">
                                                        <i class="pi pi-chart-bar text-purple-500 text-xs"></i>
                                                        <span class="font-semibold text-xs">Credits</span>
                                                        <span class="bg-purple-100 text-purple-700 text-xs font-bold px-1.5 py-0.5 rounded-full" *ngIf="getLimits().length > 0">{{ getLimits().length }}</span>
                                                    </div>
                                                </ng-template>

                                                <div class="p-4 max-h-[250px] overflow-y-auto">
                                                    <!-- Empty State -->
                                                    <div *ngIf="getLimits().length === 0" class="text-center py-6">
                                                        <i class="pi pi-sliders-h text-gray-300 text-xl mb-2"></i>
                                                        <p class="text-gray-400 text-xs">No credits configured</p>
                                                    </div>

                                                    <!-- Credits List -->
                                                    <ul class="space-y-2" *ngIf="getLimits().length > 0">
                                                        <li *ngFor="let l of getLimits()" class="flex justify-between items-center text-sm group p-2 rounded hover:bg-purple-50 transition-colors">
                                                            <span class="text-gray-600 flex items-center gap-2 group-hover:text-purple-600 transition-colors">
                                                                <i class="pi pi-sliders-h text-purple-500 text-xs"></i>
                                                                {{ getLimitLabel(l.key) || 'Select Credits' }}
                                                            </span>
                                                            <span class="font-bold text-gray-800 bg-gray-100 px-2 py-0.5 rounded">{{ l.value | number }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </p-tabPanel>

                                            <!-- FEATURES TAB -->
                                            <p-tabPanel>
                                                <ng-template pTemplate="header">
                                                    <div class="flex items-center gap-2">
                                                        <i class="pi pi-check-circle text-teal-500 text-xs"></i>
                                                        <span class="font-semibold text-xs">Features</span>
                                                        <span class="bg-teal-100 text-teal-700 text-xs font-bold px-1.5 py-0.5 rounded-full" *ngIf="getFeatures().length > 0">{{ getFeatures().length }}</span>
                                                    </div>
                                                </ng-template>

                                                <div class="p-4 max-h-[250px] overflow-y-auto">
                                                    <!-- Empty State -->
                                                    <div *ngIf="getFeatures().length === 0" class="text-center py-6">
                                                        <i class="pi pi-list text-gray-300 text-xl mb-2"></i>
                                                        <p class="text-gray-400 text-xs">No features configured</p>
                                                    </div>

                                                    <!-- Features List -->
                                                    <ul class="space-y-2" *ngIf="getFeatures().length > 0">
                                                        <li *ngFor="let f of getFeatures()" class="flex items-start gap-3 text-sm group p-2 rounded hover:bg-teal-50 transition-colors">
                                                            <div class="mt-0.5 transition-colors" [ngClass]="f.enabled ? 'bg-green-100 text-green-600' : 'bg-red-50 text-red-400'">
                                                                <i class="pi text-xs font-bold p-1 rounded-full" [ngClass]="f.enabled ? 'pi-check' : 'pi-times'"></i>
                                                            </div>
                                                            <span class="flex-1 transition-colors" [ngClass]="f.enabled ? 'text-gray-700 font-medium group-hover:text-green-700' : 'text-gray-400 line-through'">
                                                                {{ getFeatureLabel(f.key) || 'Select Feature' }}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </p-tabPanel>

                                        </p-tabView>
                                    </div>
                                    
                                </div>
                                
                                <div class="p-4 bg-gray-50 border-t border-gray-100 text-center">
                                    <button class="w-full py-3 bg-gray-900 text-white rounded-xl font-bold text-sm hover:bg-black transition-colors shadow-lg shadow-gray-200">
                                        Choose Plan
                                    </button>
                                </div>
                            </div>

                            <!-- JSON PREVIEW MINI -->
                            <div class="text-right mt-2">
                                <button type="button" class="text-xs text-blue-500 hover:text-blue-700 font-medium bg-transparent border-none cursor-pointer transition-colors" 
                                    (click)="showJson = !showJson">
                                    <i class="pi pi-code mr-1"></i>
                                    {{ showJson ? 'Hide' : 'Show' }} Payload
                                </button>
                            </div>
                            
                            <div *ngIf="showJson" class="bg-slate-900 shadow-xl p-4 rounded-xl border border-slate-800 text-left relative mt-2 animate-fadein">
                                <h3 class="text-slate-400 text-xs uppercase font-bold mb-2 tracking-wider border-b border-slate-800 pb-2">JSON Component Data</h3>
                                <pre class="text-emerald-400 text-xs max-h-60 overflow-auto font-mono scrollbar-thin">{{ getJsonPreview() | json }}</pre>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- FORM FOOTER -->
                <div class="flex justify-end gap-3 mt-8 pt-6 border-t border-gray-200">
                    <button pButton label="Cancel" class="p-button-secondary p-button-text" (click)="handleClose()"></button>
                    <button pButton label="Save Package" icon="pi pi-check" type="submit" [loading]="isLoading"></button>
                </div>

            </form>
        </div>
    </div>
</p-dialog>
